import { Route } from 'react-router';
import { CommunityFeedPage } from './CommunityFeedPage';
import { CommunityNoCareMapPage } from './CommunityNoCareMapPage';

export const CommunityRouteHandler: React.FC = () => (
    <>
        <Route exact path="/community/:caremapId/feed" render={routeParams => {
            const caremapId = routeParams.match.params.caremapId;
            return caremapId === 'undefined'
                ? <CommunityNoCareMapPage />
                : <CommunityFeedPage careMapId={caremapId} />
            ;
        }} />
    </>
);
